/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaStoreLocationsViewProps } from './citta-store-locations';

export default (props: ICittaStoreLocationsViewProps) => {
    const {CittaStoresShow, CittaStores, StoreTypeHeading, StoreHeadingLabel, StoreHeadingLabelValue, CittaStoreLocations, CittaStoresList, ViewStoresToggle, ToggleStoreName} = props;
    return (CittaStoresShow ? (
        <Module {...CittaStores}>
            <Node {...StoreTypeHeading}>
                <Node {...StoreHeadingLabel}>
                    {StoreHeadingLabelValue}
                </Node>
            </Node>
            <Node {...CittaStoreLocations}>
                {CittaStoresList}
            </Node>
            <Node {...ViewStoresToggle}>
                {ToggleStoreName}
            </Node>
    </Module>) : null
    );
};
